"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ActivitySchema = exports.addConsignmentAttachmentActivitySchema = exports.TransferConsignmentActivitySchema = exports.CompleteConsignmentActivitySchema = exports.SubmitConsignmentActivitySchema = exports.JoinBusinessActivitySchema = exports.EditPluginActivitySchema = exports.DeactivatePluginActivitySchema = exports.ActivatePluginActivitySchema = exports.GenerateCodeActivitySchema = exports.StatusActivitySchema = exports.ConditionActivitySchema = exports.ceresTagDataSchema = exports.OutConsignmentActivitySchema = exports.LinkProductActivitySchema = exports.AngusAIJoiningActivitySchema = exports.TransTokenActivitySchema = exports.DelTokenActivitySchema = exports.RemoveTagActivitySchema = exports.AddTagActivitySchema = exports.ReplaceTagActivitySchema = exports.UploadCsvActivitySchema = exports.HeightActivitySchema = exports.TreatmentActivitySchema = exports.DeceaseActivitySchema = exports.PregnancyActivitySchema = exports.WeightActivitySchema = exports.MovementActivitySchema = exports.DeleteActivitySchema = exports.UpdateActivitySchema = exports.UpdateUserActivitySchema = void 0;
const zod_1 = require("zod");
const ActivityLib = __importStar(require("../lib/activity"));
const LocationMisc = __importStar(require("../misc/location"));
//Update User Activity
exports.UpdateUserActivitySchema = zod_1.z.object({
    type: zod_1.z.literal(ActivityLib.ActivityTypeSchema.enum.UP_user_details),
    details: ActivityLib.UpdateUserActivitySchema,
    createdAt: zod_1.z.date().optional(),
    metadata: LocationMisc.locationDataSchema.optional()
});
//Update Activity
exports.UpdateActivitySchema = zod_1.z.object({
    type: zod_1.z.literal(ActivityLib.ActivityTypeSchema.enum.UP_details),
    details: ActivityLib.TokenDetailsSchema,
    nlisDetails: zod_1.z.object({
        nlisUserId: zod_1.z.string(),
        nlisPassword: zod_1.z.string(),
        nlisEmail: zod_1.z.string()
    }).optional(),
    createdAt: zod_1.z.date().optional(),
    metadata: LocationMisc.locationDataSchema.optional()
});
//Delete Activity
exports.DeleteActivitySchema = zod_1.z.object({
    type: zod_1.z.literal(ActivityLib.ActivityTypeSchema.enum.DEL_details),
    details: ActivityLib.TokenDetailsSchema,
    createdAt: zod_1.z.date().optional(),
    metadata: LocationMisc.locationDataSchema.optional()
});
//Movement Activity
exports.MovementActivitySchema = zod_1.z.object({
    type: zod_1.z.literal(ActivityLib.ActivityTypeSchema.enum.addMovement),
    details: ActivityLib.MovementActivityDetailSchema,
    createdAt: zod_1.z.date().optional(),
    metadata: LocationMisc.locationDataSchema.optional()
});
//Weight Activity
exports.WeightActivitySchema = zod_1.z.object({
    type: zod_1.z.literal(ActivityLib.ActivityTypeSchema.enum.updateWeight),
    details: ActivityLib.WeightActivityDetailSchema,
    createdAt: zod_1.z.date().optional(),
    metadata: LocationMisc.locationDataSchema.optional()
});
//Pregnancy Activity
exports.PregnancyActivitySchema = zod_1.z.object({
    type: zod_1.z.literal(ActivityLib.ActivityTypeSchema.enum.updatePregnancyStatus),
    details: ActivityLib.PregnancyActivityDetailSchema,
    createdAt: zod_1.z.date().optional(),
    metadata: LocationMisc.locationDataSchema.optional()
});
//Decease Activity
exports.DeceaseActivitySchema = zod_1.z.object({
    type: zod_1.z.literal(ActivityLib.ActivityTypeSchema.enum.updateDeceaseStatus),
    details: ActivityLib.DeceaseActivityDetailSchema,
    createdAt: zod_1.z.date().optional(),
    metadata: LocationMisc.locationDataSchema.optional()
});
//Treatment Activity
exports.TreatmentActivitySchema = zod_1.z.object({
    type: zod_1.z.literal(ActivityLib.ActivityTypeSchema.enum.addTreatment),
    details: ActivityLib.TreatmentActivityDetailSchema,
    metadata: LocationMisc.locationDataSchema.optional(),
    createdAt: zod_1.z.date()
});
//Height Activity
exports.HeightActivitySchema = zod_1.z.object({
    type: zod_1.z.literal(ActivityLib.ActivityTypeSchema.enum.updateHeight),
    details: ActivityLib.HeightActivityDetailSchema,
    // createdAt: z.date()
    metadata: LocationMisc.locationDataSchema.optional()
});
//Upload Csv Activity
exports.UploadCsvActivitySchema = zod_1.z.object({
    type: zod_1.z.literal(ActivityLib.ActivityTypeSchema.enum.uploadcsv),
    details: ActivityLib.UploadCsvActivityDetailSchema,
    // createdAt: z.date()
    metadata: LocationMisc.locationDataSchema.optional(),
});
//Replace Tag Activity
exports.ReplaceTagActivitySchema = zod_1.z.object({
    type: zod_1.z.literal(ActivityLib.ActivityTypeSchema.enum.replace_tag),
    details: ActivityLib.ReplaceTagActivityDetailSchema,
    nlisDetails: zod_1.z.object({
        nlisUserId: zod_1.z.string(),
        nlisPassword: zod_1.z.string(),
        nlisEmail: zod_1.z.string()
    }).optional(),
    createdAt: zod_1.z.date().optional(),
    metadata: LocationMisc.locationDataSchema.optional(),
});
//Add Tag Activity
exports.AddTagActivitySchema = zod_1.z.object({
    type: zod_1.z.literal(ActivityLib.ActivityTypeSchema.enum.add_tag),
    details: ActivityLib.AddRemoveTagDetailDetailSchema,
    createdAt: zod_1.z.date().optional(),
    metadata: LocationMisc.locationDataSchema.optional(),
});
//Remove Tag Activity
exports.RemoveTagActivitySchema = zod_1.z.object({
    type: zod_1.z.literal(ActivityLib.ActivityTypeSchema.enum.remove_tag),
    details: ActivityLib.AddRemoveTagDetailDetailSchema,
    createdAt: zod_1.z.date().optional(),
    metadata: LocationMisc.locationDataSchema.optional(),
});
//Del Token Activity
exports.DelTokenActivitySchema = zod_1.z.object({
    type: zod_1.z.literal(ActivityLib.ActivityTypeSchema.enum.DEL_token),
    details: ActivityLib.DelTokenActivityDetailSchema,
    createdAt: zod_1.z.date().optional(),
    metadata: LocationMisc.locationDataSchema.optional(),
});
//Trans Token Activity
exports.TransTokenActivitySchema = zod_1.z.object({
    type: zod_1.z.literal(ActivityLib.ActivityTypeSchema.enum.TRANS_token),
    details: ActivityLib.TransTokenActivityDetailSchema,
    createdAt: zod_1.z.date().optional(),
    metadata: LocationMisc.locationDataSchema.optional(),
});
//Angus AI Joining Activity
exports.AngusAIJoiningActivitySchema = zod_1.z.object({
    type: zod_1.z.literal(ActivityLib.ActivityTypeSchema.enum.angusAIJoining),
    details: ActivityLib.AngusAIJoiningActivityDetailSchema,
    createdAt: zod_1.z.date().optional(),
    metadata: LocationMisc.locationDataSchema.optional(),
});
//Link Product Activity
exports.LinkProductActivitySchema = zod_1.z.object({
    type: zod_1.z.literal(ActivityLib.ActivityTypeSchema.enum.linkProduct),
    details: ActivityLib.LinkProductActivityDetailSchema,
    createdAt: zod_1.z.date().optional(),
    metadata: LocationMisc.locationDataSchema.optional(),
});
//Out Consignment Activity
exports.OutConsignmentActivitySchema = zod_1.z.object({
    type: zod_1.z.literal(ActivityLib.ActivityTypeSchema.enum.outConsignment),
    details: ActivityLib.OutConsignmentDetailSchema,
    createdAt: zod_1.z.date().optional(),
    metadata: LocationMisc.locationDataSchema.optional(),
});
//Utils
exports.ceresTagDataSchema = zod_1.z.object({
    observationDateUTC: zod_1.z.union([zod_1.z.date(), zod_1.z.string()]),
    locationAccuracy: zod_1.z.number(),
    activityLevel: zod_1.z.union([zod_1.z.string(), zod_1.z.number()]),
    temperature: zod_1.z.number(),
    latitude: zod_1.z.number(),
    longitude: zod_1.z.number()
});
//movement activity from ceres tag
exports.ConditionActivitySchema = zod_1.z.object({
    type: zod_1.z.literal('addMovement'),
    details: exports.ceresTagDataSchema,
    createdAt: zod_1.z.date().optional(),
    metadata: LocationMisc.locationDataSchema.optional(),
});
//Status Activity
exports.StatusActivitySchema = zod_1.z.object({
    type: zod_1.z.literal(ActivityLib.ActivityTypeSchema.enum.updateStatus),
    details: ActivityLib.StatusActivityDetailSchema,
    createdAt: zod_1.z.date().optional(),
    metadata: LocationMisc.locationDataSchema.optional(),
});
//Generate Security Code Activity
exports.GenerateCodeActivitySchema = zod_1.z.object({
    type: zod_1.z.literal(ActivityLib.ActivityTypeSchema.enum.generateSecurityCode),
    details: ActivityLib.GenerateCodeActivityDetailSchema,
    createdAt: zod_1.z.date().optional(),
    metadata: LocationMisc.locationDataSchema.optional(),
});
//Activate Plugin Activity
exports.ActivatePluginActivitySchema = zod_1.z.object({
    type: zod_1.z.literal(ActivityLib.ActivityTypeSchema.enum.activatePlugin),
    details: ActivityLib.ActivatePluginActivityDetailSchema,
    createdAt: zod_1.z.date().optional(),
    metadata: LocationMisc.locationDataSchema.optional(),
});
//Deactivate Plugin Activity
exports.DeactivatePluginActivitySchema = zod_1.z.object({
    type: zod_1.z.literal(ActivityLib.ActivityTypeSchema.enum.deactivatePlugin),
    details: ActivityLib.DeactivatePluginActivityDetailSchema,
    createdAt: zod_1.z.date().optional(),
    metadata: LocationMisc.locationDataSchema.optional(),
});
//Edit Plugin Activity
exports.EditPluginActivitySchema = zod_1.z.object({
    type: zod_1.z.literal(ActivityLib.ActivityTypeSchema.enum.editPlugin),
    details: ActivityLib.EditPluginActivityDetailSchema,
    createdAt: zod_1.z.date().optional(),
    metadata: LocationMisc.locationDataSchema.optional(),
});
//Join Business Activity
exports.JoinBusinessActivitySchema = zod_1.z.object({
    type: zod_1.z.literal(ActivityLib.ActivityTypeSchema.enum.join_business),
    details: ActivityLib.JoinBusinessActivityDetailSchema,
    createdAt: zod_1.z.date().optional(),
    metadata: LocationMisc.locationDataSchema.optional(),
});
//Submit Consignment Activity
exports.SubmitConsignmentActivitySchema = zod_1.z.object({
    type: zod_1.z.literal(ActivityLib.ActivityTypeSchema.enum.submitConsignment),
    details: ActivityLib.SubmitConsignmentDetailSchema,
    createdAt: zod_1.z.date().optional(),
    metadata: LocationMisc.locationDataSchema.optional(),
});
//Submit Consignment Activity
exports.CompleteConsignmentActivitySchema = zod_1.z.object({
    type: zod_1.z.literal(ActivityLib.ActivityTypeSchema.enum.completeConsignment),
    details: ActivityLib.CompleteConsignmentDetailSchema,
    createdAt: zod_1.z.date().optional(),
    metadata: LocationMisc.locationDataSchema.optional(),
});
exports.TransferConsignmentActivitySchema = zod_1.z.object({
    type: zod_1.z.literal(ActivityLib.ActivityTypeSchema.enum.transferConsignment),
    details: ActivityLib.TransferConsignmentDetailSchema,
    createdAt: zod_1.z.date().optional(),
    metadata: LocationMisc.locationDataSchema.optional(),
});
exports.addConsignmentAttachmentActivitySchema = zod_1.z.object({
    type: zod_1.z.literal(ActivityLib.ActivityTypeSchema.enum.addConsignmentAttachment),
    details: ActivityLib.addConsignmentAttachmentDetailSchema,
    createdAt: zod_1.z.date().optional(),
    metadata: LocationMisc.locationDataSchema.optional(),
});
exports.ActivitySchema = zod_1.z.union([
    exports.UpdateUserActivitySchema,
    exports.UpdateActivitySchema,
    exports.DeleteActivitySchema,
    exports.MovementActivitySchema,
    exports.WeightActivitySchema,
    exports.PregnancyActivitySchema,
    exports.DeceaseActivitySchema,
    exports.TreatmentActivitySchema,
    exports.HeightActivitySchema,
    exports.UploadCsvActivitySchema,
    exports.ReplaceTagActivitySchema,
    exports.DelTokenActivitySchema,
    exports.TransTokenActivitySchema,
    exports.AngusAIJoiningActivitySchema,
    exports.LinkProductActivitySchema,
    exports.OutConsignmentActivitySchema,
    exports.ConditionActivitySchema,
    exports.StatusActivitySchema,
    exports.GenerateCodeActivitySchema,
    exports.ActivatePluginActivitySchema,
    exports.DeactivatePluginActivitySchema,
    exports.EditPluginActivitySchema,
    exports.JoinBusinessActivitySchema,
    exports.SubmitConsignmentActivitySchema,
    exports.CompleteConsignmentActivitySchema,
    exports.TransferConsignmentActivitySchema,
    exports.RemoveTagActivitySchema,
    exports.AddTagActivitySchema,
    exports.addConsignmentAttachmentActivitySchema
]);
